export default "__VITE_ASSET__BqKYea5i__"